<template>
  <el-main class='main' style="padding-top: 60px;padding-left: 260px;padding-right: 260px;">
      <el-row>
        <el-form :model="form">
          <el-form-item label="名称" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" :label-width="formLabelWidth">
            <el-input v-model="form.descr" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input v-model="form.addr" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="企业标签" :label-width="formLabelWidth">
            <el-input v-model="form.labels" autocomplete="off"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经度" :label-width="formLabelWidth">
                <el-input v-model="form.lng" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" :label-width="formLabelWidth">
                <el-input v-model="form.lat" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="信用编码" :label-width="formLabelWidth">
                <el-input v-model="form.code" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区域编码" :label-width="formLabelWidth">
                <el-input v-model="form.areaId" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="注册资金" :label-width="formLabelWidth">
                <el-input v-model="form.fund" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法定代表人" :label-width="formLabelWidth">
                <el-input v-model="form.legalRepresentative" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话" :label-width="formLabelWidth">
                <el-input v-model="form.phone" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登记机关" :label-width="formLabelWidth">
                <el-input v-model="form.registrationAuthority" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="行业" :label-width="formLabelWidth">
                <el-select v-model="form.industry" clearable placeholder="请选择">
                  <el-option
                    v-for="item in industry"
                    :key="item.val"
                    :label="item.val"
                    :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业类型" :label-width="formLabelWidth">
                <el-select v-model="form.type" clearable placeholder="请选择">
                  <el-option
                    v-for="item in types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业状态" :label-width="formLabelWidth">
                <el-radio-group v-model="form.status" size="medium">
                  <el-radio-button label=1>经营中</el-radio-button>
                  <el-radio-button label=2>歇业中</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="submitForm()" style="background-color: #209323;width: 200px;" >确 定</el-button>
        </el-row>
      </el-row>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      
      industry: [],
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        descr: null,
        addr: null,
        lng: null,
        lat: null,
        code: null,
        areaId: null,
        businessLicenseUrl: null,
        fund: null,
        legalRepresentative: null,
        phone: null,
        industry: null,
        registrationAuthority: null,
        type: null,
        status: null,
        labels: null
      },
      formLabelWidth: '120px',
      types: [
        {id: 1, name: '国有企业'},
        {id: 2, name: '集体所有制'},
        {id: 3, name: '私营企业'},
        {id: 4, name: '股份制企业'},
        {id: 5, name: '有限合伙企业'},
        {id: 6, name: '联营企业'},
        {id: 7, name: '外商投资企业'},
        {id: 8, name: '个人独资企业'},
        {id: 9, name: '股份合作企业'}
      ]
    }
  },
  created () {
    
    this.loadIndustry()
    this.seDetail()
  },
  methods: {
    loadIndustry () {
      let that = this
      requestService.get('/dict/listByKkey?kkey=industry', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.industry = res.data.body
      })
    },
    seDetail () {
      let that = this
      let userInfo = JSON.parse(localStorage.getItem('userInfo') + '')
      if (!userInfo || !userInfo.organizationId) {
        return
      }
      requestService.get(`/organization/getOne?id=${userInfo.organizationId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.form = res.data.body
      })
    },
    submitForm () {
      let that = this
      requestService.post('/organization/edit', that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/organization/Index.vue